import { type ReactElement, type ReactNode, useState } from 'react';
import Navbar from '../Navbar';
import SiteNoticeBanners from '../SiteNoticeBanners';
import { useUserInfo } from '@/providers/user-info-provider/hooks/use-user-info';
import { mergeSiteNotices, siteConfig } from '@/app/config/global';
import { useSiteNotices } from '@/providers/site-notice-provider/utils/use-site-notices';
import { TermsOfUseModal } from '@/features/TermsOfUse';

interface Properties {
  readonly children: ReactNode;
}

const Layout = ({ children }: Properties): ReactElement => {
  const user = useUserInfo();
  const { siteNotices: runtimeSiteNotices } = useSiteNotices();
  const siteNotices = mergeSiteNotices([...siteConfig.siteNotices, ...runtimeSiteNotices]);
  const [isGuidelinesOpen, setIsGuidelinesOpen] = useState(false);

  return (
    <>
      <Navbar
        key={`${user?.givenName ?? ''}${user?.surname ?? ''}`}
        title={`${siteConfig.title} - ${siteConfig.subTitle}`}
        userFirstName={user?.givenName ?? ''}
        userLastName={user?.surname ?? ''}
        isSignedIn={!!user}
        onOpenGuidelines={() => {
          setIsGuidelinesOpen(true);
        }}
      />
      <SiteNoticeBanners siteNotices={siteNotices} />
      <main>{children}</main>
      {isGuidelinesOpen && (
        <TermsOfUseModal
          onClose={() => {
            setIsGuidelinesOpen(false);
          }}
        />
      )}
    </>
  );
};

export default Layout;
